import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import DoctorAuditListComponent from 'src/components/views/Doctor/DoctorAuditListPage';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isDomestic } }: IStoreState) => ({
  isDomestic,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DoctorAuditListComponent);



// WEBPACK FOOTER //
// ./src/containers/DoctorAuditList.ts